import { render, staticRenderFns } from "./card.vue?vue&type=template&id=0e34b930&scoped=true"
import script from "./card.vue?vue&type=script&lang=ts"
export * from "./card.vue?vue&type=script&lang=ts"
import style0 from "./card.vue?vue&type=style&index=0&id=0e34b930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e34b930",
  null
  
)

export default component.exports